export default __webpack_public_path__ + "static/media/about.63242c02.jpg";